
// 图纸内的经常用的一些公共方法
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import Kscreenshot from "@/CommonDP/utils/kscreenshot/src/kss";

export default {
  // 引擎截图
  startScreenShot(type) {
    return new Promise((resolve) => {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
      const textType = !!isAndroid;
      let cutpic = "";
      mongeApiMlib.mongeScreenCapture(true, type).then(canvas => {
        const kss = new Kscreenshot({
          // 截图工具栏 暂时隐藏文字(ios不支持)
          toolShow: {
            text: textType
          },
          immediately: false,
          endCB: imgs => {
            cutpic = imgs;
            resolve(cutpic);
          }
        });
        kss.startScreenShot(canvas);
      });
    });
  }

};
